import type { PageContext } from 'vike/types';
import { initLocale } from '@/i18n';

export const onBeforeRenderClient = (pageContext: PageContext) => {
    void initLocale(pageContext.locale || pageContext.defaultLocale);
};
